<template>
  <div class="grid grid-cols-1 mx-5 my-5 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-6">

    <BoardCard title="Пользователь">
      <p class="text-gray-600 mb-2">Email: -</p>
      <p class="text-gray-600 mb-2">Статсус: не подтвержден</p>
      <button class="px-4 py-2 mt-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors cursor-pointer">
        Сменить пароль
      </button>
    </BoardCard>

    <BoardCard title="Telegram Bot">
      <div class="text-gray-600 mb-4">
        <ProfileTgBot/>
      </div>
    </BoardCard>
  </div>
</template>

<script>
import ProfileTgBot from "@/components/block/ProfileTgBot.vue"
import BoardCard from "@/components/BoardCard.vue";

export default {
  name: 'SettingsPage',
  components: {BoardCard, ProfileTgBot},
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>